import React from 'react'
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined';
import ContactPhoneOutlinedIcon from '@mui/icons-material/ContactPhoneOutlined';
import BalanceOutlinedIcon from '@mui/icons-material/BalanceOutlined';
import "./navbar.css"
import { motion } from "framer-motion"
import { NavLink } from 'react-router-dom';

const nav = {
    hidden:{ x: -300},
    visible:{ x: 0}
}
const Navbar = () => {
  return (
    <motion.nav className="navbar"
        initial="hidden"
        animate="visible"
        transition={{delay: 3}}
        variants={nav}
    >
        <section className="nav">
            <NavLink to="/profile" className={({ isActive })=> isActive ? "active": ""}>
                <div className="nav-item">
                <AccountCircleOutlinedIcon className="nav-icon"/> 
                        <div className="toast">
                            <span>profile page</span>
                        </div>
                </div>
            </NavLink>
            <NavLink to="/skills" className={({ isActive })=> isActive ? "active": ""}>
                <div className="nav-item">
                    <BalanceOutlinedIcon className="nav-icon"/> 
                    <div className="toast">
                    <span>skills page</span>
                    </div>
                </div>
            </NavLink>
            <NavLink to="/projects" className={({ isActive })=> isActive ? "active": ""}>
                <div className="nav-item">
                    <AssignmentOutlinedIcon className="nav-icon"/> 
                    <div className="toast">
                    <span>projects page</span>
                    </div>
                </div>
            </NavLink>
            <NavLink to="/contact" className={({ isActive })=> isActive ? "active": ""}>
                <div className="nav-item">
                    <ContactPhoneOutlinedIcon className="nav-icon"/> 
                    <div className="toast">
                    <span>contact page</span>
                    </div>
                </div>
            </NavLink>
        </section>
    </motion.nav>
  )
}

export default Navbar